export const normalizeSlug = (slug = '') => {
    return slug
        .replaceAll('.', '')
        .replaceAll(':', '')
        .replaceAll(',', '')
        .replaceAll('-', '')
        .replaceAll('?', '')
        .replaceAll('!', '')
        .split(' ')
        .join('_')
        .toLowerCase()
        .replaceAll('..', '.');
};
export const sleep = (duration) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            /* istanbul ignore next */
            resolve();
        }, duration);
    });
};
export const prettyPrintJSON = (json) => {
    // Convert JSON object to string with 2-space indentation
    const jsonString = JSON.stringify(json, null, 2);
    // Replace specific characters for color coding
    return jsonString.replace(/(".*?"|null|true|false|\d+)/g, match => {
        let cls = "number";
        if (/^".*"$/.test(match)) {
            cls = "string";
        }
        else if (/true|false/.test(match)) {
            cls = "boolean";
        }
        else if (/null/.test(match)) {
            cls = "null";
        }
        return `<span class="${cls}">${match}</span>`;
    });
};
